document.addEventListener("DOMContentLoaded", () => {

  function showBlockPage() {
    const overlay = document.createElement("div");

    overlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100vh;
      background: #f9fafb;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 99999999999999999999999;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
    `;

    overlay.innerHTML = `
      <div style="background:#fff;border:1px solid #ddd;border-radius:12px;box-shadow:0 5px 20px rgba(0,0,0,0.15);padding:40px;text-align:center;max-width:90%;width:360px;">
        <div style="margin-bottom:20px;">
          <img src="https://cdn-icons-png.flaticon.com/512/565/565547.png" 
               alt="Protection Logo" width="64" height="64" />
        </div>

        <h2 style="color:#d32f2f;font-size:2rem;margin-bottom:10px;font-weight:bold">
          Access Restricted
        </h2>

        <p style="color:#555;font-size:1.3rem;">
          Sorry, access to this store is not available from your location.
          Please contact us if you believe this is an error.
        </p>
      </div>
    `;

    document.body.style.overflow = "hidden";
    document.body.appendChild(overlay);
  }

  async function checkAccess() {
    const apis = [
      "https://ipinfo.io/json",
      "https://ipwho.is"
    ];

    for (const api of apis) {
      try {
        const response = await fetch(api);
        const data = await response.json();

        // Block a specific IP
        if (data.ip === "160.224.161.21" || data.ip === "54.147.179.218" || data.ip === "160.225.14.2") {
          showBlockPage();
          return;
        }

        break;
      } catch (error) {
        continue;
      }
    }
  }

  checkAccess();
});
